import React, { useEffect, useState } from 'react';
import { FormElement, FormInput, FormLabel, FormNumberInput, DragHandle } from "../components/StyledElements";
import { Handle, Position, useUpdateNodeInternals } from '@xyflow/react';
import { NodeCard } from './NodeCard';
import { CloseButton } from '../components/CloseButton';

export const ConditionalNodeCard = ({ onAdd = () => { }, style = {} }) => {
  return (
    <NodeCard title="Conditional" description="Allow input to be conditionally directed to an output" onAdd={() => onAdd(300, 150)} style={style} />
  )
};

export const ConditionalNode = ({ id, data }) => {
  const updateNodeInternals = useUpdateNodeInternals();
  const [localData, setLocalData] = useState({
    sourceCount: 1,
    labels: ["source 1"],
  });

  useEffect(() => {
    console.log("!!!MODEL: ", data.model);
    if (!data) {
      return;
    }

    const labels = data.labels || [];
    while (labels.length < data.sourceCount) {
      labels.push("source " + (labels.length + 1));
    }

    setLocalData({
      sourceCount: data.sourceCount || 1,
      labels: labels,
    });
  }, [data]);

  if (!localData) {
    //return null; // or a loading indicator
  }

  return (
    <div style={{ height: `${170 + (localData.sourceCount + 1) * 68}px`, display: "flex", flexDirection: "column", padding: "10px", border: "1px solid var(--main-border-color)", borderRadius: "8px", backgroundColor: "var(--content-item-bg)", width: "100%" }} >

      <CloseButton onClick={() => {
        data.onDelete(id);
      }} />
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <DragHandle />
        <FormLabel label="Conditional" />
        <FormElement>
          <FormLabel label="Source Count" />
          <FormNumberInput
            value={localData.sourceCount}
            onChange={(e) => {
              const newLabels = localData.labels.slice(0, e.target.value);
              while (newLabels.length < e.target.value) {
                newLabels.push("source " + (newLabels.length + 1));
              }
              setLocalData({ ...localData, sourceCount: e.target.value, labels: newLabels });
              data.onUpdateData(id, { sourceCount: e.target.value, labels: newLabels });
              updateNodeInternals(id);
            }}
            min={1}
            step={1}
          />
        </FormElement>
        {
          Array.from({ length: localData.sourceCount }).map((_, index) => (
            <FormElement key={index}>
              <FormInput
                placeholder={`Enter label for source ${index + 1}`}
                value={localData.labels[index]}
                onChange={(e) => {
                  const newLabels = [...localData.labels];
                  newLabels[index] = e.target.value;
                  setLocalData({ ...localData, labels: newLabels });
                  data.onUpdateData(id, { labels: newLabels });
                  updateNodeInternals(id);
                }}
              />
            </FormElement>
          ))
        }
        <FormElement>
          <FormInput
            value="default"
            disabled
          />
        </FormElement>
      </div>
      <Handle type="target" position={Position.Left} style={{ height: "12px", width: "12px" }} />
      {
        Array.from({ length: localData.sourceCount }).map((_, index) => (
          <Handle key={index} type="source" position={Position.Right} style={{ top: `${110 + (index + 1) * 68}px`, height: "12px", width: "12px" }} id={localData.labels[index]} />
        ))
      }
      <Handle type="source" position={Position.Right} style={{ top: `${110 + (localData.sourceCount + 1) * 68}px`, height: "12px", width: "12px" }} id="default" />
    </div>
  );
};

export default ConditionalNode;

